// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3qzpA","time":"_1jINq"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Timeline/TimelineEvent.scss
 ** module id = 107
 ** module chunks = 0
 **/